import Vue from "vue"
import apiClient from "@/utils/cb-client"

import { MANAGE_PAYMENTS } from "@/store/common/auth"
import { checkPaymentGateway, CDN } from "@/components/modules/hosted-pages/LazyLoadPaymentComponents"
import ImportHelper from '@/utils/chunkImportWrapper'

export const hostedPageState = {
  loaded: false,
  request_source: undefined,
  partially_loaded: false,
  show_bank_review: false,
  voucher_data: {},
}


const SET_DATA = "SET_DATA";
export const SET_LOADED = "SET_LOADED";
export const SET_PARTIALLY_LOADED = "SET_PARTIALLY_LOADED";
const SET_REQUEST_SOURCE = "SET_REQUEST_SOURCE";
const SET_PREFERRED_CURRENCY_CODE = "SET_PREFERRED_CURRENCY_CODE";
const SET_INVOICE_PO_NUMBER = "SET_INVOICE_PO_NUMBER";
const SET_HP_MODEL = "SET_HP_MODEL";
const SHOW_BANK_REVIEW = 'SHOW_BANK_REVIEW'
const SET_VOCHER_DATA = 'SET_VOCHER_DATA'

export const hostedPageActions = {
  _fetch_data({commit, state, dispatch, rootState, getters}, token) {
    return new Promise((resolve, reject) => {
      // apiClient.hosted_pages.get({}, {token: token}).then(function(data) {
      try{
        var data = window.hpData;
        commit(SET_DATA, data.content);
        commit(SET_REQUEST_SOURCE, data.content.hp_request_source);
        commit(SET_PREFERRED_CURRENCY_CODE, data.content.preferred_currency_code);
        commit(SET_INVOICE_PO_NUMBER, data.content.invoice_po_number);
        commit(SET_HP_MODEL, data.content.hp_model);

        if(data.content.type == "checkout_gift") {
          dispatch('mark_as_gift', data.content.type == "checkout_gift");
        }

        if(data.content.type == "checkout_existing" && data.content.subscription_handle){
          dispatch('load_subscription', data.content.subscription_handle);
        }

        dispatch('set_pm_list', data.pm_list);
        dispatch('set_action_pages_redirect_url', data.action_pages_redirect_url);
        dispatch('set_collect_now_transactions', data.content.transactions);
      
        /* fetching e-invoicing only for PC 2.0  */
        if (data.content.hp_model == 'items') {
          dispatch('set_einvoice_configuration');
        }

        /* e-invoicing enabled only for PC 2.0  */
        if (data.content.hp_model == 'items' && data.content.entity_identifiers && data.content.entity_identifiers.length) {
          /* entity_identifiers passed via Hosted Pages APIs : CHECKOUT NEW / EXISTING / ONE TIME */
          dispatch('set_einvoice_schemes_hp', data.content.entity_identifiers);
        }

        // rootstate can be authenticated if jwt is being set.
        // authentication will be initied in main.js
        if(rootState.auth.authenticated) {
          // if hosted page cusomer id is different from the authenticated customer id
          if(data.content.customer_handle && data.content.customer_handle != rootState.auth.customer_handle) {
            dispatch('reset_auth');
          }

          if(data.content.hp_request_source == "plan") {
            dispatch('reset_auth');
          }

          if(data.content.hp_request_source == "api" && !data.content.auth_token_type) {
            dispatch('reset_auth');
            window.cbPostMessage("cb.unauthenticated");
          }
        }

        if(rootState.auth.scopes.indexOf(MANAGE_PAYMENTS) > -1 && data.content.type != "manage_payment_sources") {
          dispatch('reset_auth');
        }
        if(data.content.auth_token_type && data.content.auth_token_type == "hp_token") {
          dispatch("set_hp_token_auth", data.content.customer_handle);
        }
        if(data.content.business_entity_id) {
          dispatch("set_business_entity_id", data.content.business_entity_id);
        }
        resolve(true);
      }
      catch(error) {
        reject(error)
      };
    }).then(() => {
      if(checkPaymentGateway().loadChargebeejs) {
        // Do not wait for load
        window.cbjsLoader.then(() => Chargebee.getInstance().load("3ds-handler")); 
      }
      return true;
    });
  // });
  },

  reset_load({commit, state}) {
    commit(SET_PARTIALLY_LOADED, false);
    commit(SET_LOADED, false);
  },

  load_voucher_data({commit, state, rootState, dispatch}, invoiceId) {
    return apiClient.voucher.fetch_data({invoice_id: invoiceId, status: "active" }).then(data => {
      commit(SET_VOCHER_DATA, data.list);
    });
  },
}


export const hostedPageMutations = {
  [SET_DATA] (state, data) {
    Vue.set(state, 'data', data);
  },
  [SET_LOADED] (state, status) {
    state.loaded = status;
  },
  [SET_PARTIALLY_LOADED] (state, status) {
    state.partially_loaded = status;
  },
  [SET_REQUEST_SOURCE] (state, request_source) {
    state.request_source = request_source;
  },
  [SET_PREFERRED_CURRENCY_CODE] (state, preferred_currency_code) {
    state.preferred_currency_code = preferred_currency_code;
  },
  [SET_INVOICE_PO_NUMBER] (state, invoice_po_number) {
    state.invoice_po_number = invoice_po_number;
  },
  [SET_HP_MODEL] (state, hp_model="classic") {
    state.hp_model = hp_model;
  },
  [SHOW_BANK_REVIEW] (state, show) {
    state.show_bank_review = show;
  },
  [SET_VOCHER_DATA] (state, data) {
    state.voucher_data = data;
  },
}

export const hostedPageGetters = {
  hp_partially_loaded: state => state.partially_loaded,
  hp_loaded: state => state.loaded,
  hp_type: state => state.data && state.data.type,
  hp_model: state => state.hp_model,
  is_checkout_new: (state, getters) => getters.hp_type == "checkout_new",
  is_checkout_existing: (state, getters) => getters.hp_type == "checkout_existing",
  is_checkout_gift: (state, getters) => getters.hp_type == "checkout_gift",
  is_claim_gift: (state, getters) => getters.hp_type == "claim_gift",
  is_checkout_one_time: (state, getters) => getters.hp_type == "checkout_one_time",
  hp_request_source: state => state.request_source,
  is_hp_from_api: state => state.request_source == "api",
  is_hp_from_plan: state => state.request_source == "plan",
  is_items_model: state => state.hp_model == 'items',
  product_catalog_ver: (state, getters) => getters.is_items_model ? 'pc_v2' : 'pc_v1',

  preferred_currency_code: state => state.preferred_currency_code,
  invoice_po_number: state => state.invoice_po_number,
  can_edit_billing_address: (state, getters) => {
    return getters.subscription_count == 0 || (getters.is_checkout_existing && getters.subscription_count == 1);
  },
  show_bank_review: state => state.show_bank_review,
  voucher_data: state => state.voucher_data,
}